import React, { useEffect, useState } from "react";
import {
  TextField,
  Grid,
  Button,
  Paper,
  MenuItem,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Tab,
  Snackbar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AccordionActions,
  Divider,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { TabContext, TabList, TabPanel, Alert } from "@material-ui/lab";
import { useForm } from "react-hook-form";
import { makeStyles } from "@material-ui/core/styles";
import withServices from "../hocs/withServices";
import { NavLink } from "react-router-dom";
import Loader from "./utils/Loader";
import FileUpload from "./utils/FileUpload";
import Constants from "../common/constants";

function Aet({ services }) {
  const [loading, setLoading] = useState(false);
  const [formIsActive, setFormIsActive] = useState(false);
  const [haveIIN, setHaveIIN] = useState(false);

  const [haveEnglishCertificate, setHaveEnglishCertificate] = useState(false);
  const [haveOlympiadCertificate, setHaveOlympiadCertificate] = useState(false);

  const [englishCertificateTypes, setEnglishCertificateTypes] = useState([]);
  const [olympiadCertificateTypes, setOlympiadCertificateTypes] = useState([]);

  const [selectedEnglishCertificateType, setSelectedEnglishCertificateType] =
    useState("");
  const [selectedOlympiadCertificateType, setSelectedOlympiadCertificateType] =
    useState("");

  const [englishExamScan, setEnglishExamScan] = useState();
  const [olympiadCertificateScan, setOlympiadCertificateScan] = useState();

  const [englishExamScanPath, setEnglishExamScanPath] = useState();
  const [olympiadCertificateScanPath, setOlympiadCertificateScanPath] =
    useState();

  const [open, setOpen] = useState(true);
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [tabValue, setTabValue] = useState("1");
  const [selectedDate, setSelectedDate] = useState("");
  const [forAstana, setForAstana] = useState();
  const [selectedRegion, setSelectedRegion] = useState("");
  const [oneDate, setOneDate] = useState();
  const [regions, setRegions] = useState();
  const [myRequests, setMyRequests] = useState(null);
  const [myRequestsForYear, setMyRequestsForYear] = useState(null);
  const [attemps, setAttemps] = useState(0);
  const [myResult, setMyResult] = useState();
  const [dates, setDates] = useState();
  const { register, handleSubmit } = useForm();
  const [iin, setIin] = useState();
  const dayjs = require("dayjs");
  
  const limitAttemps = 3;

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  function handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setShowError(false);
    setShowSuccess(false);
  }

  const handleChangeDate = (event, newValue) => {
    setSelectedDate(newValue);
  };

  const fetchData = async () => {
    setLoading(true);
    await services.aet.checkAttemps().then((response) => {
      setAttemps(response.data);
    });
    await services.aet.getAllRegionsByIsUsedTrue().then((response) => {
      setRegions(response.data);
    });
    await services.aet.getAllDatesFromNow().then((response) => {
      setDates(response.data);
    });
    await services.aet.getAllRequestsByPrincipal().then((response) => {
      if (response.data.length !== 0) {
        setMyRequests(response.data);
      }
    });
    await services.personalPage.getPersonalInformation().then((response) => {
      if (
        response.data?.iin !== null &&
        response.data?.iin !== "" &&
        response.data?.iin !== undefined
      ) {
        setHaveIIN(true);
      } else {
        setHaveIIN(false);
      }
    });
    await services.documentPage.getDocuments().then((response) => {
      if (response.data?.englishCertificate?.id != null) {
        setHaveEnglishCertificate(true);
      } else {
        setHaveEnglishCertificate(false);
      }
      if (response.data?.olympiadCertificate?.id != null) {
        setHaveOlympiadCertificate(true);
      } else {
        setHaveOlympiadCertificate(false);
      }
    });
    await services.admissionInfo.getSelected().then((response) => {
      if (response?.data) {
        const { data } = response;
        setSelectedEnglishCertificateType(data.englishCertificateType?.id);
        setSelectedOlympiadCertificateType(data.olympiadCertificateType?.id);

        setEnglishExamScan(data.englishCertificate?.id);
        setOlympiadCertificateScan(data.olympiadCertificate?.id);

        setEnglishExamScanPath(data.englishCertificate?.path);
        setOlympiadCertificateScanPath(data.olympiadCertificate?.path);
      }
    });
    await services.admissionInfo
      .getEnglishCertificateTypes()
      .then((response) => {
        setEnglishCertificateTypes(response.data);
      });
    await services.admissionInfo
      .getOlympiadCertificateTypes()
      .then((response) => {
        setOlympiadCertificateTypes(response.data);
      });
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [services]);

  useEffect(() => {
    if (
      dates?.length !== 0 &&
      haveIIN &&
      !(attemps >= limitAttemps) 
      // && (myResult === undefined ||
      //   myResult?.firstModule !== null ||
      //   myResult?.secondModule !== null)
    ) {
      setFormIsActive(true);
    } else {
      setFormIsActive(false);
    }
  }, [haveIIN, attemps, myResult, dates]);

  useEffect(() => {
    if (attemps === 1) {
      services.aet.getRequestsForThisYear().then((response) => {
        if (response.data.length !== 0) {
          setMyRequestsForYear(response.data);
        } else setMyRequestsForYear(undefined);
      });
    } else {
      setMyRequestsForYear(undefined);
    }
  }, [attemps]);

  useEffect(() => {
    if (myRequestsForYear?.length === 1) {
      services.aet
        .getResultByRequest(myRequestsForYear[0].id)
        .then((response) => {
          if (response.data) {
            setMyResult(response.data);
          }
        });
    } else {
      setMyResult(undefined);
    }
  }, [myRequestsForYear]);

  useEffect(() => {
    if (selectedDate) {
      services.aet.getDateById(selectedDate).then((response) => {
        setOneDate(response.data);
      });
    }
  }, [selectedDate]);

  useEffect(() => {
    if (selectedRegion === 1) {
      setForAstana(true);
    } else {
      setForAstana(false);
    }
    setSelectedDate("");
  }, [selectedRegion]);

  const handleSubmitIiin = () => {
    if (iin?.length === 12) {
      const data = {
        iin: iin,
      };
      services.personalPage
        .personalInformation(data)
        .then((response) => {
          setHaveIIN(true);
        })
        .catch((error) => {
          setHaveIIN(false);
        })
        .finally(() => { });
    }
  };

  const handleSubmitCertificate = () => {
    const data = {
      englishCertificateType: selectedEnglishCertificateType || null,
      englishCertificateId: englishExamScan || null,
      olympiadCertificateType: selectedOlympiadCertificateType || null,
      olympiadCertificateId: olympiadCertificateScan || null,
    };
    services.admissionInfo
      .postAdmissionInfo(data)
      .then(() => {
        alert("Ваши данные успешно сохранены");
        fetchData();
        setErrorMessage(null);
      })
      .catch((error) => {
        setErrorMessage("Произошла ошибка при обработке запроса");
        alert("Не удалось сохранить данные");
      });
  };

  const handleCancelRequest = (requestId) => {
    if (requestId) {
      setLoading(true);
      services.aet
        .cancelRequest(requestId)
        .then((response) => {
          if (response.data.length !== 0) {
            setMyRequests(response.data);
            setDates();
          } else {
            setMyRequests();
            setDates();
          }
        })
        .finally(() => {
          fetchData();
          setSelectedDate("");
          setSelectedRegion("");
        });
    }
  };

  const onSubmit = (data) => {
    if (selectedDate && selectedRegion) {
      data.date = selectedDate;
      data.region = selectedRegion;
      setLoading(true);
      services.aet
        .createRequest(data)
        .then((response) => {
          setShowSuccess(true);
          setOpen(true);
          services.aet.getAllRequestsByPrincipal().then((response) => {
            setMyRequests(response.data);
          });
          services.aet.checkAttemps().then((response) => {
            setAttemps(response.data);
            if (response.data >= 2) {
              setFormIsActive(false);
            } else {
              setFormIsActive(true);
            }
          });
        })
        .catch((error) => {
          setErrorMessage(error.response.data.message);
          setShowError(true);
          setOpen(true);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setShowError(true);
      setOpen(true);
    }
  };

  useEffect(() => {
    if (!open) {
      setErrorMessage("");
    }
  }, [open]);

  const useStyles = makeStyles((theme) => ({
    pageContent: {
      [theme.breakpoints.up("sm")]: {
        margin: theme.spacing(5),
        padding: theme.spacing(3),
      },
      [theme.breakpoints.down("xs")]: {
        margin: theme.spacing(0),
        padding: theme.spacing(1),
      },
    },
    form: {
      width: "100%", // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    txtField: {
      marginTop: 15,
    },
    submit: {
      marginTop: 15,
    },
    requestInfo: {
      marginTop: 15,
      marginBottom: 15,
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      "& p": {
        textAlign: "left",
      },
    },
    infoAlert: {
      marginTop: 15,
    },
    testTitle: {
      [theme.breakpoints.up("sm")]: {
        marginBottom: 10,
        fontSize: "1.5rem",
      },
      [theme.breakpoints.down("xs")]: {
        margin: theme.spacing(0),
        fontSize: "1rem",
      },
    },
    tabTitle: {
      [theme.breakpoints.down("xs")]: {
        fontSize: "0.75rem",
      },
    },
    accordionDiv: {
      marginTop: 30,
    },
    englishCertificate: {
      marginTop: 10,
      marginBottom: 15,
      [theme.breakpoints.down("xs")]: {
        paddingTop: "50px",
      },
    },
  }));

  const classes = useStyles();
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Paper className={classes.pageContent}>
          <Grid container justify="center" spacing={3}>
            <Grid item xs={12} md={8} lg={10}>
              <Typography className={classes.testTitle}>
                Регистрация на вступительный экзамен Astana IT University
              </Typography>
              <TabContext value={tabValue}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    onChange={handleChangeTab}
                    aria-label="lab API tabs example"
                    textColor="primary"
                    indicatorColor="primary"
                  >
                    <Tab
                      label="Записаться"
                      value="1"
                      className={classes.tabTitle}
                    />
                    <Tab
                      label="Мои записи"
                      value="2"
                      className={classes.tabTitle}
                    />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  {formIsActive && (
                    <>
                      <form
                        onSubmit={handleSubmit(onSubmit)}
                        className={classes.form}
                        noValidate
                        disabled
                      >
                        <TextField
                          variant="outlined"
                          fullWidth
                          label="Город сдачи"
                          select
                          required
                          {...register("region")}
                          value={selectedRegion}
                          onChange={(e) => {
                            setSelectedRegion(e.target.value);
                          }}
                        >
                          <MenuItem value="none" disabled>
                            Выберите один из вариантов
                          </MenuItem>
                          {regions?.map((region) => (
                            <MenuItem key={region.id} value={region.id}>
                              {region.name}
                            </MenuItem>
                          ))}
                        </TextField>
                        <TextField
                          variant="outlined"
                          fullWidth
                          label="Дата экзамена"
                          className={classes.txtField}
                          select
                          required
                          {...register("date")}
                          value={selectedDate}
                          onChange={(e) => {
                            setSelectedDate(e.target.value);
                          }}
                        >
                          <MenuItem value="none" disabled>
                            Выберите один из вариантов
                          </MenuItem>
                          {dates
                            ?.filter((date) => date.forAstana === forAstana)
                            .map((date) => (
                              <MenuItem
                                key={date?.id}
                                value={date?.id}
                                onClick={(event) =>
                                  handleChangeDate(event, date?.id)
                                }
                              >
                                {dayjs(date?.date).format("DD-MM-YYYY HH:mm").toString().concat(" - ").concat(date?.isSampleTest ? "Пробный" : "Основной")}
                              </MenuItem>
                            ))}
                        </TextField>
                        {selectedDate && (
                          <Grid container className={classes.requestInfo}>
                            <Alert
                              variant="outlined"
                              severity="info"
                              className={classes.infoAlert}
                            >
                              <Typography>
                                Данный поток AITU Excellence Test состоится в{" "}
                                {dayjs(oneDate?.date).format(
                                  "HH:mm DD-MM-YYYY"
                                )}
                              </Typography>
                              <Typography>
                                <strong>
                                  SMS с логином и паролем придет за день до
                                  экзамена
                                </strong>
                              </Typography>
                            </Alert>
                          </Grid>
                        )}
                        <Button
                          type="submit"
                          fullWidth
                          variant="contained"
                          color="primary"
                          className={classes.submit}
                        >
                          Регистрация
                        </Button>
                      </form>
                      <Accordion className={classes.accordionDiv}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography className={classes.heading}>
                            Сертификаты IELTS, TOEFL IBT, TOEFL ITP, APTIS,
                            InterPress, AITU iQyn
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container spacing={1}>
                            {haveEnglishCertificate ? (
                              <Grid item xs={12} md={12} lg={12}>
                                <Alert variant="outlined" severity="success">
                                  Вы загрузили сертификат, подтверждающий знание
                                  английского языка. Вы освобождаетесь от
                                  первого модуля тестирования
                                </Alert>
                              </Grid>
                            ) : (
                              <>
                                <Grid item xs={12} md={12} lg={12}>
                                  <Alert variant="outlined" severity="info">
                                    Если вы являетесь обладателем сертификатов
                                    IELTS, TOEFL IBT, TOEFL ITP, APTIS,
                                    InterPress, AITU iQyn, вы освобождаетесь от
                                    сдачи первого модуля.
                                    <br />
                                  </Alert>
                                </Grid>
                              </>
                            )}
                            <Grid item xs={12} md={12} lg={12}>
                              <TextField
                                fullWidth
                                select
                                variant="outlined"
                                label="Выберите имеющийся у вас тип экзамена для подтверждения знаний английского языка"
                                className={classes.englishCertificate}
                                onChange={(e) =>
                                  setSelectedEnglishCertificateType(
                                    e.target.value
                                  )
                                }
                                value={selectedEnglishCertificateType}
                              >
                                <MenuItem value="none" disabled>
                                  Выберите один из вариантов
                                </MenuItem>
                                {englishCertificateTypes.map(
                                  (englishCertificateType) => {
                                    return (
                                      <MenuItem
                                        key={englishCertificateType.id}
                                        value={englishCertificateType.id}
                                      >
                                        {englishCertificateType.name}
                                      </MenuItem>
                                    );
                                  }
                                )}
                              </TextField>
                              {selectedEnglishCertificateType &&
                                selectedEnglishCertificateType !== 5 && (
                                  <Grid item xs={12} md={8} lg={12}>
                                    <FileUpload
                                      helperText="Скан сертификата, подтверждающего знания английского языка"
                                      fileType={
                                        Constants.FILE_TYPES.englishCertificate
                                      }
                                      file={englishExamScan}
                                      filePath={englishExamScanPath}
                                      handleSetFileId={(fileId) =>
                                        setEnglishExamScan(fileId)
                                      }
                                    />
                                  </Grid>
                                )}
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                        <AccordionActions>
                          <Button size="small">Отмена</Button>
                          <Button
                            size="small"
                            color="primary"
                            onClick={handleSubmitCertificate}
                          >
                            Сохранить
                          </Button>
                        </AccordionActions>
                      </Accordion>
                      <Accordion className={classes.accordionDiv}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel2a-content"
                          id="panel2a-header"
                        >
                          <Typography className={classes.heading}>
                            Сертификаты призёра {olympiadCertificateTypes.map((certificate, index) => index !== olympiadCertificateTypes.length - 1 ? `${certificate.name}, ` : certificate.name)}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container spacing={1}>
                            {haveOlympiadCertificate ? (
                              <Grid item xs={12} md={12} lg={12}>
                                <Alert
                                  variant="outlined"
                                  severity="success"
                                  className={classes.infoAlert}
                                >
                                  Вы загрузили сертификат призёра олимпиады. Вы
                                  освобождаетесь от второго модуля тестирования
                                </Alert>
                              </Grid>
                            ) : (
                              <>
                                <Grid item xs={12} md={12} lg={12}>
                                  <Alert
                                    variant="outlined"
                                    severity="info"
                                    className={classes.infoAlert}
                                  >
                                    Лица, имеющие сертификаты призёра сертификаты призёра {olympiadCertificateTypes.map((certificate, index) => index !== olympiadCertificateTypes.length - 1 ? `${certificate.name}, ` : certificate.name)} освобождаются от
                                    сдачи модуля по основам компьютерных наук и
                                    логики.
                                  </Alert>
                                </Grid>
                              </>
                            )}
                            <Grid item xs={12} md={12} lg={12}>
                              <Grid item xs={12} md={8} lg={12}>
                                <TextField
                                  fullWidth
                                  select
                                  variant="outlined"
                                  label="Выберите тип имеющегося у вас сертификата олимпийского призёра"
                                  className={classes.englishCertificate}
                                  onChange={(e) =>
                                    setSelectedOlympiadCertificateType(
                                      e.target.value
                                    )
                                  }
                                  value={selectedOlympiadCertificateType}
                                >
                                  <MenuItem value="none" disabled>
                                    Выберите один из вариантов
                                  </MenuItem>
                                  {olympiadCertificateTypes.map(
                                    (olympiadCertificateType) => {
                                      return (
                                        <MenuItem
                                          key={olympiadCertificateType.id}
                                          value={olympiadCertificateType.id}
                                        >
                                          {olympiadCertificateType.name}
                                        </MenuItem>
                                      );
                                    }
                                  )}
                                </TextField>
                              </Grid>

                              {selectedOlympiadCertificateType && (
                                <Grid item xs={12} md={8} lg={12}>
                                  <FileUpload
                                    helperText="Скан сертификаты призёра AITU iCode, AITU Open, Жаутыковской или Евразийской олимпиады, Сертификат foundation"
                                    fileType={
                                      Constants.FILE_TYPES.olympiadCertificate
                                    }
                                    file={olympiadCertificateScan}
                                    filePath={olympiadCertificateScanPath}
                                    handleSetFileId={(fileId) =>
                                      setOlympiadCertificateScan(fileId)
                                    }
                                  />
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                        <AccordionActions>
                          <Button size="small">Отмена</Button>
                          <Button
                            size="small"
                            color="primary"
                            onClick={handleSubmitCertificate}
                          >
                            Сохранить
                          </Button>
                        </AccordionActions>
                      </Accordion>
                    </>
                  )}
                  {!haveIIN ? (
                    <>
                      <Typography>
                        Для регистрации на экзамены необходим номер ИИН
                      </Typography>

                      <Grid item xs={12} md={8} lg={6}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          margin="normal"
                          value={iin}
                          label="ИИН"
                          onChange={(e) => {
                            let value = e.target.value;

                            value = value.replace(/[^0-9]/gi, "");

                            setIin(value);
                          }}
                          error={iin?.length < 12 && iin?.length > 0}
                          helperText={
                            iin?.length < 12 && iin?.length > 0
                              ? "ИИН не может быть меньше 12 цифр"
                              : " "
                          }
                          inputProps={{ maxLength: 12 }}
                        />
                        <Button
                          variant="outlined"
                          color="primary"
                          disabled={!(iin?.length === 12)}
                          onClick={handleSubmitIiin}
                        >
                          Сохранить
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  {attemps >= limitAttemps ? (
                    <>
                      <Typography>
                        Вы уже зарегистрировались на тест трижды в этом году
                      </Typography>
                    </>
                  ) : null}
                  {myResult !== undefined &&
                    myResult?.firstModule === null &&
                    myResult?.secondModule === null ? (
                    <>
                      <Typography>
                        У вас есть экзамен, который вы еще не сдали!
                      </Typography>
                    </>
                  ) : null}
                  {dates?.length === 0 ? (
                    <>
                      <Typography>Даты тестирования недоступны!</Typography>
                    </>
                  ) : null}
                </TabPanel>
                <TabPanel value="2">
                  {myRequests === null ? (
                    <Typography>У вас нет экзаменов</Typography>
                  ) : (
                    <>
                      <TableContainer>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">Регион</TableCell>
                              <TableCell align="center">Дата</TableCell>
                              <TableCell align="center">Время</TableCell>
                              <TableCell align="center">
                                Оценка по английскому языку
                              </TableCell>
                              <TableCell align="center">
                                Оценка по ИКТ
                              </TableCell>
                              <TableCell align="center">Действие</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {myRequests?.map((myRequest) => (
                              <TableRow
                                key={myRequest.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="center">
                                  {myRequest?.region}
                                </TableCell>
                                <TableCell align="center">
                                  {dayjs(myRequest?.date).format("DD-MM-YYYY")}
                                </TableCell>
                                <TableCell align="center">
                                  {dayjs(myRequest?.date).format("HH:mm")}
                                </TableCell>
                                <TableCell align="center">
                                  {myRequest?.engGrade
                                    ? myRequest?.engGrade
                                    : "-"}
                                </TableCell>
                                <TableCell align="center">
                                  {myRequest?.iktGrade
                                    ? myRequest?.iktGrade
                                    : "-"}
                                </TableCell>
                                <TableCell align="center">
                                  {dates?.some(
                                    (item) => item.date === myRequest?.date
                                  ) ? (
                                    <>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="secondary"
                                        className={classes.submit}
                                        size="small"
                                        onClick={() =>
                                          handleCancelRequest(myRequest.id)
                                        }
                                      >
                                        Отменить
                                      </Button>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  )}
                </TabPanel>
              </TabContext>
            </Grid>
          </Grid>
          {showError && (
            <div>
              <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                ContentProps={{
                  "aria-describedby": "message-id",
                }}
              >
                <Alert
                  onClose={handleClose}
                  severity="warning"
                  variant="filled"
                  elevation={6}
                  sx={{ width: "100%" }}
                >
                  {errorMessage !== "" ? (
                    errorMessage
                  ) : (
                    <>Не удалось зарегистрироваться на экзамен!</>
                  )}
                </Alert>
              </Snackbar>
            </div>
          )}
          {showSuccess && (
            <div>
              <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                ContentProps={{
                  "aria-describedby": "message-id",
                }}
              >
                <Alert
                  onClose={handleClose}
                  severity="success"
                  variant="filled"
                  elevation={6}
                  sx={{ width: "100%" }}
                >
                  Вы успешно зарегистрировались на экзамен!
                </Alert>
              </Snackbar>
            </div>
          )}
        </Paper>
      )}
    </>
  );
}

export default withServices()(Aet);
